import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../../utils/immutable";
import { IAction } from "../../../../models/Action";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { compose } from "redux";
import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const {
  STEP_ONE,
  STEP_TWO,
  STEP_THREE,
  MANUALS_SECTIONS_TABLE,
  SECTION_DETAIL,
  ATTACHMENTS,
  ATTACHMENT,
  ATTACHMENT_ROLES,
  SELECTED_ROLES,
  ROLES,
  REQUEST_STATE,
  ADDED_ROLES,
  REMOVED_ROLES,
  TOTAL_ROLES,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.SECTIONS_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [STEP_ONE, MANUALS_SECTIONS_TABLE, LOADER_IDENTIFIER],
      true,
      state
    ),
  [actionTypes.SECTIONS_REQUEST_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          id: data.id,
          name: data.name,
          description: data.description,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [STEP_ONE, MANUALS_SECTIONS_TABLE, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet([STEP_ONE, MANUALS_SECTIONS_TABLE, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.SECTIONS_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [STEP_ONE, MANUALS_SECTIONS_TABLE, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.CREATE_SECTION]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.CREATE_SECTION_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.CREATE_SECTION_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_SECTION]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.DELETE_SECTION_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.DELETE_SECTION_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.SECTION_DETAIL_REQUEST]: (state: any, action: any) => {
    return compose(
      immutableSet([STEP_TWO, SECTION_DETAIL, LIST_IDENTIFIER], action.payload),
      immutableSet([STEP_TWO, SECTION_DETAIL, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.SECTION_DETAIL_GET_ATTACHMENTS_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([STEP_TWO, SECTION_DETAIL, LOADER_IDENTIFIER], true, state),

  [actionTypes.SECTION_DETAIL_GET_ATTACHMENTS_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([STEP_TWO, SECTION_DETAIL, ATTACHMENTS], action.payload),
      immutableSet([STEP_TWO, SECTION_DETAIL, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.SECTION_DETAIL_GET_ATTACHMENTS_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet([STEP_TWO, SECTION_DETAIL, LOADER_IDENTIFIER], false, state),

  [actionTypes.EDIT_SECTION]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.EDIT_SECTION_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.EDIT_SECTION_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_ATTACHMENT_FROM_SECTION]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.DELETE_ATTACHMENT_FROM_SECTION_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.DELETE_ATTACHMENT_FROM_SECTION_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.SAVE_ATTACHMENT_IN_SECTION]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.SAVE_ATTACHMENT_IN_SECTION_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.SAVE_ATTACHMENT_IN_SECTION_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.RESET_SECTION_DETAIL]: (state: any, action: any) => {
    return compose(
      immutableSet([STEP_TWO, SECTION_DETAIL, LIST_IDENTIFIER], []),
      immutableSet([STEP_TWO, SECTION_DETAIL, LOADER_IDENTIFIER], false),
      immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.PENDING)
    )(state);
  },

  [actionTypes.GET_ROLE_IN_ATTACHMENT_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_THREE, ATTACHMENT, LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_ROLE_IN_ATTACHMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([STEP_THREE, ATTACHMENT, ATTACHMENT_ROLES], action.payload),
      immutableSet([STEP_THREE, ATTACHMENT, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_ROLE_IN_ATTACHMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([STEP_THREE, ATTACHMENT, LOADER_IDENTIFIER], false, state),

  [actionTypes.GET_ATTACHMENT_INFO]: (state: any, action: any) => {
    return compose(
      immutableSet([STEP_THREE, ATTACHMENT, LIST_IDENTIFIER], action.payload),
      immutableSet([STEP_THREE, ATTACHMENT, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.RESET_ATTACHMENT_INFO]: (state: any, action: any) => {
    return compose(
      immutableSet([STEP_THREE, ATTACHMENT, LIST_IDENTIFIER], []),
      immutableSet([STEP_THREE, ATTACHMENT, ATTACHMENT_ROLES], []),
      immutableSet([STEP_THREE, ATTACHMENT, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.MODIFY_SELECTED_ROLES]: (state: any, action: any) =>
    immutableSet([STEP_THREE, SELECTED_ROLES], action.payload, state),

  [actionTypes.GET_ALL_ROLES]: (state: any, action: any) =>
    immutableSet([STEP_THREE, ROLES, LOADER_IDENTIFIER], false, state),
  [actionTypes.GET_ALL_ROLES_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.roles.length > 0 &&
      action.payload.roles.forEach((role: any) => {
        const tempRow: {} = {
          idRole: role,
          role: role,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet([STEP_THREE, ROLES, LIST_IDENTIFIER], mappedResponse),
      immutableSet([STEP_THREE, ROLES, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_ALL_ROLES_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_THREE, ROLES, LOADER_IDENTIFIER], false, state),

  [actionTypes.SET_SELECTED_ROLE]: (state: any, action: any) =>
    immutableSet([STEP_THREE, SELECTED_ROLES], action.payload, state),

  [actionTypes.ADD_SELECTED_ROLES]: (state: any, action: any) =>
    immutableSet([STEP_THREE, ADDED_ROLES], action.payload, state),

  [actionTypes.REMOVE_SELECTED_ROLES]: (state: any, action: any) =>
    immutableSet([STEP_THREE, REMOVED_ROLES], action.payload, state),

  [actionTypes.MODIFY_TOTAL_ROLES]: (state: any, action: any) =>
    immutableSet([STEP_THREE, TOTAL_ROLES], action.payload, state),

  [actionTypes.UPDATE_ROLES_IN_ATTACHMENT]: (state: any, action: any) =>
    immutableSet([STEP_THREE, REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.UPDATE_ROLES_IN_ATTACHMENT_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_THREE, REQUEST_STATE], IResponseState.SUCCESS),
      immutableSet([STEP_THREE, SELECTED_ROLES], [])
    )(state),
  [actionTypes.UPDATE_ROLES_IN_ATTACHMENT_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_THREE, REQUEST_STATE], IResponseState.ERROR),
      immutableSet([STEP_THREE, SELECTED_ROLES], [])
    )(state),

  [actionTypes.RESET_STATE_MANUALS_MANAGEMENT]: (state: any, action: any) =>
    emptyState,
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
